import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, assemblies, filters = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const [assemblyType, setAssemblyType] = useState(filters.assembly_type || '')
  const [status, setStatus] = useState(filters.status || '')
  const [year, setYear] = useState(filters.year || '')

  const applyFilters = () => {
    router.get(`/m/${tenant.slug}/properties/${property.id}/assemblies`, {
      assembly_type: assemblyType || undefined,
      status: status || undefined,
      year: year || undefined,
    }, { preserveState: true, replace: true })
  }

  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i)

  return (
    <Box>
      <PageHeader
        title="Versammlungen"
        breadcrumbs={[
          { label: 'Versammlungen' },
        ]}
        actions={
          <Button variant="contained" startIcon={<AddIcon />}
            onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/assemblies/new`)}
            data-testid="new-assembly-btn"
          >
            Neue Versammlung
          </Button>
        }
      />

      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Typ</InputLabel>
          <Select value={assemblyType} label="Typ" onChange={(e) => setAssemblyType(e.target.value)}>
            <MenuItem value="">Alle</MenuItem>
            <MenuItem value="regular">Ordentlich</MenuItem>
            <MenuItem value="extraordinary">Außerordentlich</MenuItem>
            <MenuItem value="circular_resolution">Umlaufbeschluss</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Status</InputLabel>
          <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
            <MenuItem value="">Alle</MenuItem>
            <MenuItem value="planned">Geplant</MenuItem>
            <MenuItem value="invited">Eingeladen</MenuItem>
            <MenuItem value="held">Durchgeführt</MenuItem>
            <MenuItem value="minutes_completed">Protokoll fertig</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel>Jahr</InputLabel>
          <Select value={year} label="Jahr" onChange={(e) => setYear(e.target.value)}>
            <MenuItem value="">Alle</MenuItem>
            {years.map((y) => <MenuItem key={y} value={String(y)}>{y}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="outlined" size="small" onClick={applyFilters}>Filtern</Button>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Datum</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Typ</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Ort</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>TOP</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Beschlüsse</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assemblies.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Versammlungen gefunden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {assemblies.map((assembly) => (
              <TableRow key={assembly.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`/m/${tenant.slug}/properties/${property.id}/assemblies/${assembly.id}`)}
                data-testid={`assembly-row-${assembly.id}`}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>{assembly.date}</Typography>
                  {assembly.time && <Typography variant="caption" color="text.secondary">{assembly.time}</Typography>}
                </TableCell>
                <TableCell><StatusBadge type="assembly_type" value={assembly.assembly_type} /></TableCell>
                <TableCell>{assembly.location}</TableCell>
                <TableCell>{assembly.agenda_item_count}</TableCell>
                <TableCell>{assembly.resolution_count}</TableCell>
                <TableCell><StatusBadge type="assembly_status" value={assembly.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
